import styled from 'styled-components';
export const HeaderStyled = styled.div `
  width: 100%;
  display: flex;
`;
export const HeaderDataContainerStyled = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-bottom: 1px solid #eaecf0;
  padding: 12px 24px;
  color: #1f89ff;
  width: ${({ width }) => `${width - 48}px`};
`;
export const EmptyTableRowStyled = styled.div `
  ${({ emptyRows, rowHeight }) => `height: ${(rowHeight || 34) * emptyRows}px`};
`;
export const TableContainerStyled = styled.div `
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
export const TableContentContainerStyled = styled.div `
  overflow-x: auto;
`;
export const TableDataContainerStyled = styled.div `
  display: grid;
  padding: 0px 14px;
`;
export const EmptyTableRowsContainerStyled = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ emptyRows, rowHeight }) => `height: ${(rowHeight || 44) * emptyRows}px`};
  width: 100%;
`;
export const NoResultsFoundContainerStyled = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;
//# sourceMappingURL=styled.js.map